<template>
  <div class="empty-state">
    <FontAwesomeIcon class="empty-state__icon" :icon="icon" size="lg" />
    <p v-if="title" class="empty-state__title">{{ title }}</p>
    <p v-if="subtitle" class="empty-state__subtitle">{{ subtitle }}</p>
    <div v-if="$slots.actions" class="empty-state__actions">
      <slot name="actions">
        <transition name="fade">
          <PortalTarget v-if="showPortal" :name="actionPortalName" />
        </transition>
      </slot>
    </div>
  </div>
</template>

<script>
import { Debounce } from '@/utils'

import { PortalTarget } from 'portal-vue'
import { ButtonComponent } from 'vue-elder-button'

export default {
  props: {
    icon: {
      type: [String, Array],
      default: () => ['fal', 'low-vision'],
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    actionPortal: Boolean,
    actionPortalName: {
      type: String,
      default: 'empty-state-actions',
    },
  },
  watch: {
    actionPortal: {
      handler: Debounce(function (val) {
        this.showPortal = val
      }, 200),
      immediate: true,
    },
  },
  data() {
    return {
      showPortal: false,
    }
  },
  components: {
    ButtonComponent,
    PortalTarget,
  },
}
</script>

<style lang="scss">
.empty-state {
  margin-inline: auto;
  padding: 2rem;
  text-align: center;
  max-width: 500px;
  word-wrap: break-word;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__icon {
    margin-bottom: 0.5rem;
  }

  &__title {
    margin: 0;
  }

  &__actions {
    margin-top: 1rem;
  }

  &__subtitle {
    opacity: 0.5;
    margin: 0.2rem 0 0 0;
    max-width: 38ch;
    line-height: 1.2;
  }

  &__actions {
    margin-top: 1rem;
  }
}
</style>
